import { render, staticRenderFns } from "./BuyerProfile.vue?vue&type=template&id=6cc64a8c"
import script from "./BuyerProfile.vue?vue&type=script&lang=js"
export * from "./BuyerProfile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports